/**
 * GDEV-157: 로그인 이후 복귀할 path 의 안전성 검증.
 *
 * open redirect 공격 방지 — 동일 오리진 path 만 허용:
 *  - `/` 로 시작해야 함
 *  - `//` 로 시작 금지 (scheme-relative URL 차단)
 *  - `:` 포함 금지 (scheme 포함 URL 차단)
 *  - 빈 문자열 / null / undefined → null 반환
 */
export function sanitizeReturnTo(value: string | null | undefined): string | null {
  if (!value) return null
  if (typeof value !== 'string') return null
  if (!value.startsWith('/')) return null
  if (value.startsWith('//')) return null
  if (value.includes(':')) return null
  return value
}

/**
 * HF OAuth 왕복을 넘어 복귀 경로를 보존한다 (QA H-7).
 *
 * 로그인은 HuggingFace 로 **전체 페이지 이동**을 한다. `returnTo` 는 Zustand
 * 인메모리 상태라 그 순간 사라지고, 콜백 화면은 홈으로만 돌아갔다. 그래서
 * 동료에게 받은 데이터셋 링크로 들어오면 로그인 후 홈에 떨어져 매번 다시
 * 찾아야 했다.
 *
 * sessionStorage 에 담아 왕복을 견디게 한다. 탭을 닫으면 사라지고, 읽는 즉시
 * 지운다. 값은 읽을 때 다시 검증한다 — 저장소는 스크립트가 건드릴 수 있다.
 */
const RETURN_TO_KEY = 'robotai_return_to'

export function rememberReturnTo(value: string | null | undefined): void {
  const safe = sanitizeReturnTo(value)
  try {
    if (safe) sessionStorage.setItem(RETURN_TO_KEY, safe)
    else sessionStorage.removeItem(RETURN_TO_KEY)
  } catch {
    /* private 모드 등에서 sessionStorage 가 막히면 홈 복귀로 떨어진다 */
  }
}

export function consumeReturnTo(): string | null {
  try {
    const raw = sessionStorage.getItem(RETURN_TO_KEY)
    sessionStorage.removeItem(RETURN_TO_KEY)
    return sanitizeReturnTo(raw)
  } catch {
    return null
  }
}
